<template>
    <modal :id="`preview-file-modal-${id}`" class="preview-file-modal" size="lg">
        <template slot="title">
            <span v-text="file.name"></span>
        </template>
        <template slot="body">
            <div class="preview-container">
                <div class="preview-pdf" v-if="isPDF">
                    <iframe :src="file.url" style="width: 100%; min-height:500px" frameborder="0"></iframe>
                </div>
                <div class="preview-image" v-if="isImage">
                    <img :src="file.url" :alt="file.url">
                </div>
                <div v-if="isOther" class="text-center">
                    Preview not Available<br>Click "Download"
                </div>
            </div>
        </template>
        <template slot="footer">
            <div class="d-flex">
                <button class="btn btn-dafault" @click="closeModal(`preview-file-modal-${id}`)">
                    Close
                </button>
                <div class="controls">
                    <button class="previous" @click="previous()">
                        <i class="far fa-arrow-alt-circle-left"></i>
                    </button>
                    <button class="next" @click="next()">
                        <i class="far fa-arrow-alt-circle-right"></i>
                    </button>
                </div>
            </div>
            <button type="submit" class="btn btn-success" @click="redirectTo(file.url, '_blank')">Download</button>
        </template>
    </modal>
</template>
<script>
    export default {

        props: {
            file: {
                type: Object,
                required: true,
            },
            id: {
                type: Number,
                required: false,
                default: '',
            },

        },

        data() {
            return {
                imageTypes: [
                    'image/png',
                    'image/jpeg',
                    'image/gif',
                ],
            }
        },

        methods: {

            previous(){
                this.$emit('previous')
            },

            next(){
                this.$emit('next')
            }

        },

        computed: {
            isPDF() {
                return this.file.type == 'application/pdf';
            },

            isImage() {
                return this.imageTypes.includes(this.file.type);
            },

            isOther(){
                return !this.isPDF && !this.isImage;
            }
        }
    }
</script>